import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './responsive.css';
import App from './App';
import { LanguageProvider } from './i18n';
import { installGlobalErrorMonitoring } from './utils/errorMonitoring';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </>
);



installGlobalErrorMonitoring();
